import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useTheme } from "@mui/material/styles";

function TrialUpgradePopup({ isTrialPlan, open, onClose }) {
  const theme = useTheme();
  const iconColor = theme.palette.mode === 'dark' ? theme.palette.grey[200] : theme.palette.grey[600];
  const navigate = useNavigate();

  // Mark popup as shown when it's first displayed
  useEffect(() => {
    if (open) {
      const today = new Date().toISOString().split('T')[0];
      sessionStorage.setItem('trialUpgradePopupShown', today);
    }
  }, [open]);

  const handleGetOffer = () => {
    // Set flag to auto-open the upgrade modal on the profile page
    sessionStorage.setItem('openUpgradeModal', 'true');
    
    // Redirect to profile page
    navigate('/fx-dashboard/profile');
    onClose();
  };
  

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        style: { 
            backgroundColor: theme.palette.background.default || '#f0f2f5',
          boxShadow: 'none',
          maxWidth: '500px'
        }
      }}
    >
      <DialogContent>
        <Card sx={{ 
          position: 'relative',
          overflow: 'hidden',
          backgroundColor: 'rgba(76,175,80,0.1)',
          border: '2px solid #4CAF50',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.14)',
          '@keyframes pulse': {
            '0%': { boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.7)' },
            '70%': { boxShadow: '0 0 0 10px rgba(76, 175, 80, 0)' },
            '100%': { boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)' }
          },
          animation: 'pulse 2s infinite'
        }}>
          <MDBox p={3} textAlign="center">
            <MDTypography variant="h5" color="success" fontWeight="bold" mb={2}>
              Special Trial Upgrade Offer
            </MDTypography>
            <MDTypography variant="h3" mb={1}>
              <strong>$5</strong>
              <MDTypography variant="caption" ml={0.5}>first month</MDTypography>
            </MDTypography>
            <MDTypography variant="body2" mb={1}>
              Continue your premium access for just $5 for your first month!
            </MDTypography>
            <MDTypography variant="caption" color="text" display="block" mb={2}>
              Then $19.99/month. Cancel anytime.
            </MDTypography>
            <MDBox display="flex" justifyContent="space-between" mt={3}>
              <MDButton
                variant="text"
                color="black"
                onClick={onClose}
                sx={{ width: '45%' }}
              >
                Later
              </MDButton>
              <MDButton
                variant="gradient"
                color="success"
                onClick={handleGetOffer}
                sx={{ width: '50%', minHeight: '42px' }}
              >
                Get Special Offer
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </DialogContent>

      <style jsx global>{`
        @keyframes pulse {
          0% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(76, 175, 80, 0); }
          100% { box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
        }
      `}</style>
    </Dialog>
  );
}

export default TrialUpgradePopup;